import { Navigate, Outlet, RouteObject } from 'react-router';

import AuthGuard from 'components/guard/AuthGuard';
import MainLayout from 'components/layout/MainLayout';
import PolicyLayout from 'components/layout/PolicyLayout';
import CheckBlockedAssetsProvider from 'components/provider/CheckBlockedAssets';
import OnlyAndroidDevice from 'components/provider/OnlyAndroidDevice';
import RewardAccessGate from 'components/provider/RewardAccessGate';

import DashboardPage from 'pages/dashboard';
// import PasswordForgotPage from 'pages/passwordForgot';
import PolicyPage from 'pages/policy';
import SignInPage from 'pages/signIn';
import SignInWithPasswordPage from 'pages/signInWithPassword';

import { PATH } from './paths';

export const routes: RouteObject[] = [
  {
    path: '/',
    element: (
      <AuthGuard>
        <CheckBlockedAssetsProvider>
          <MainLayout />
        </CheckBlockedAssetsProvider>
      </AuthGuard>
    ),
    children: [
      // replace 없이 이동하면 history 에 '/' 가 남아 뒤로가기가 즉시 /dashboard 로 되돌아온다
      { index: true, element: <Navigate to={PATH.DASHBOARD} replace /> },
      {
        path: PATH.DASHBOARD,
        element: (
          <RewardAccessGate>
            <DashboardPage />
          </RewardAccessGate>
        ),
      },
    ],
  },
  {
    path: PATH.AUTH.SIGN_IN,
    element: (
      <OnlyAndroidDevice>
        <Outlet />
      </OnlyAndroidDevice>
    ),
    children: [
      { index: true, element: <SignInPage /> },
      { path: PATH.AUTH.SIGN_IN_WITH_PASSWORD, element: <SignInWithPasswordPage /> },
    ],
  },
  // { path: PATH.AUTH.PASSWORD_FORGOT, element: <PasswordForgotPage /> },
  {
    path: PATH.POLICY.INDEX,
    element: <PolicyLayout />,
    children: [{ index: true, element: <PolicyPage /> }],
  },
  { path: '*', element: <Navigate to={PATH.DASHBOARD} replace /> },
];
